require.context('./assets');
require('angular-i18n/angular-locale_' + (localStorage.getItem('lang') == 'ar' ? 'ar-sa' : 'en-us'));

import './app-core/core.module';

import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;



// WEBPACK FOOTER //
// ./src/main.js